module.exports = __webpack_public_path__ + "img/common_empty.c4086fb2.png";